import React from 'react';
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';

const PostsPreview = ({ posts }) => {
	const recentPosts = posts.slice(0, 4);

	return (
		<div className='dashboard-panel'>
			<div className='dashboard-panel__header'>
				<div>
					<h3 className='dashboard-panel__title'>Marketing Posts</h3>
					<p className='dashboard-panel__subtitle'>
						Recent content shared with your audience
					</p>
				</div>

				<Link to='/marketing' className='dashboard-panel__link'>
					View all
				</Link>
			</div>

			{recentPosts.length > 0 ? (
				<div className='dashboard-list'>
					{recentPosts.map((post) => (
						<div className='dashboard-list-item' key={post._id}>
							<div className='dashboard-list-item__icon dashboard-list-item__icon--post'>
								<FileText size={18} />
							</div>

							<div className='dashboard-list-item__body'>
								<h4>{post.title || 'Untitled post'}</h4>
								<p>{post.description || 'No description available'}</p>
							</div>
						</div>
					))}
				</div>
			) : (
				<div className='dashboard-empty'>
					No marketing posts yet. Publish content to engage local customers.
				</div>
			)}
		</div>
	);
};

export default PostsPreview;
